var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('intro-hero'),_vm._v(" "),_c('partner-logos'),_vm._v(" "),_c('we-want-you'),_vm._v(" "),_c('recent-news',{attrs:{"posts":_vm.posts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }